import { GridColDef } from '@mui/x-data-grid';
import React from 'react'
import { WSLItem } from '../../../../interfaces/Stocks/wslitems';

export const useColumnsWSLItems = () => {

  const columnsWSLItems: GridColDef<WSLItem>[] = [];

  return {
    columnsWSLItems,
  }
}
